import { render } from "./PainelComponent.vue?vue&type=template&id=d70bf7b2"
import script from "./PainelComponent.vue?vue&type=script&lang=js"
export * from "./PainelComponent.vue?vue&type=script&lang=js"

import "./PainelComponent.vue?vue&type=style&index=0&id=d70bf7b2&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_sindico\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__